type Metric = Readonly<{ timestamp: Date, numberOfConnectedDatapoints: number, numberOfReceivedMessages: number, date: Date }>

export type HourlyMetric = Pick<Metric, 'numberOfConnectedDatapoints' | 'numberOfReceivedMessages' | 'timestamp'>

export type DailyMetric = Pick<Metric, 'numberOfConnectedDatapoints' | 'numberOfReceivedMessages' | 'date'>

export type Metrics = Readonly<{ hourly: HourlyMetric[], daily: DailyMetric[], isPortalReachable: boolean }>
